module.exports = __webpack_public_path__ + "img/helen-after.a6a7943e.png";